<template>
  <div @click="navigateTo(localePath(URL))" class="cursor-pointer hover:shadow-lg">
    <div class="flex flex-col md:flex-row bg-card rounded-lg overflow-hidden shadow-lg">
      <div class="md:w-1/2">
        <img
          src="/img/turquoise-tropical-beautiful-outdoors-tourism.jpg"
          alt="Tourists enjoying a guided tour"
          class="w-full h-full object-cover"
        />
      </div>
      <div
        class="md:w-1/2 bg-gradient-to-r from-ts_blue_to to-ts_blue_from flex flex-col justify-center items-center p-8 text-center"
      >
        <img aria-hidden="true" alt="plane-icon" src="/img/plane.png" class="mb-4" />
        <h2 class="text-2xl md:text-3xl font-semibold text-white mb-4">
          {{ $t('Looking for more tours?') }}
        </h2>
        <button class="bg-black text-white py-2 px-4 rounded-full hover:bg-black/80">
          {{
            $t('See all {city-name} tours', {
              'city-name': props.cityName,
            })
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
const route = useRoute();

//Get the current path
const props = defineProps({
  cityName: {
    type: String,
    required: true,
  },
  URL: {
    type: String,
    required: true,
  },
});
</script>
